(function () {
    var AllPeriodsCtrl = (function () {
        function AllPeriodsCtrl() {
            this.init.apply(this, arguments);
        }

        AllPeriodsCtrl.prototype = {
            init: function ($scope, $state, $rootScope, $stateParams, localStorageService, $mdDialog, $ionicScrollDelegate, $timeout, MKioskService, $message, $q, $loading) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.$ionicScrollDelegate = $ionicScrollDelegate;
                this.$timeout = $timeout;
                this.MKioskService = MKioskService;
                this.$message = $message;
                this.$q = $q;
                this.$loading = $loading;
                this.loaded = false;

                this.titleKey = 'HomeCharges';
                this.backTo = 'internal.mycharges';

                this.myChargesType = 'Home';// this var use only when come from my charges              

                this.loadData().then(angular.bind(this, function (list) {
                    // NF-724: Adapt translation as origial server result by En 
                    for(var d of list) {
                        // NF-890: With special value, we need to translate the text
                        if (d.Period === 'lbConsumptionsForOngoingPeriod') {
                            // d.EventId = 'OnGoing';
                            d.Name = this.$message.get('lbConsumptionsForOngoingPeriod')
                        } else {                            
                            d.Name =  moment(d.Period, 'YYYY-MM' , 'en')
                            .locale(moment.locale())
                            .format('MMMM YYYY');

                            d.PowerConsumed = d.Energy;
                        }
                    }
                    
                    this.list = list;
                }), this.$message.error).finally(() => {
                    this.loaded = true;
                    this.$loading.hide();
                });
            },

            back: function () {
                this.$state.go(this.backTo);
            },
            loadData: function () {

                // NF-1004: depend on the current url/state we will have different behaviour of loading data or go back
                if (this.$state) {
                    if (this.$state.current.name === 'internal.homecharges-all-periods') {                                                
                        this.myChargesType = 'Home';                        
                    } else if (this.$state.current.name === 'internal.publiccharges-all-periods') {
                        this.titleKey = 'PublicCharges';                        
                        this.myChargesType = 'Public';                        
                    } else if (this.$state.current.name === 'internal.officecharges-all-periods') {
                        this.titleKey = 'OfficeCharges';                        
                        this.myChargesType = 'Office';                        
                    }

                    this.loaded = false;
                    this.$loading.show();
                    return this.MKioskService.getMyChargesConsumptionForAllPeriods(this.myChargesType);
                }                

                return this.$q.resolve([]);
                
            },
            gotoEvent: function (item) {
                var currentState = "internal.homecharges-all-periods";
                if (this.$state) {
                    currentState = this.$state.current.name;
                }

                this.$state.go(`internal.mycharges-consumption-details`, { period: item.Period, type: this.myChargesType, pre: this.$state.current.name });                
            }
        };
        AllPeriodsCtrl.$inject = ['$scope', '$state', '$rootScope', '$stateParams', 'localStorageService', '$mdDialog', '$ionicScrollDelegate', '$timeout', 'MKioskService', '$message', '$q', '$Loading'];
        return AllPeriodsCtrl;
    }());
    angular.module('internal.homecharges').controller('AllPeriodsCtrl', AllPeriodsCtrl)
})();


